import React from 'react';
import { UserProfileInputs } from './Inputs';
import { useLanguage } from '@base/LanguageProvider';
import { Page, PageTitle } from '@styled/Page';
import { useAuth } from '../../providers/AuthProvider';
function UserProfilePage() {
    var L = useLanguage().L;
    var user = useAuth().user;
    if (!user) {
        return null;
    }
    return (React.createElement(Page, null,
        React.createElement(PageTitle, null,
            React.createElement("h2", null, L('My profile information'))),
        React.createElement(UserProfileInputs, { initialUser: user })));
}
export default UserProfilePage;
